<div>

  <div class="notify">
    Choose when the status for due dates changes to
    <span class="label due-soon" style="padding: 3px">DUE SOON</span>
  </div>

  <div class="edit-date-settings">
    <div class="edit-date-settings-options pb-3">
      <div class="p-l-5">
        <mat-radio-group [(ngModel)]="data.input.dateSettingsModel.isGlobalChecked">
          <mat-radio-button  [value]="true">All Report Types</mat-radio-button>
        </mat-radio-group>
      </div>
      <div>
        <mat-form-field appearance="outline" class="mb-0">
          <mat-label>Unit Value</mat-label>
          <mat-select [(ngModel)]="data.input.dateSettingsModel.globalDueDate.unitValue"
                      [disabled]="!data.input.dateSettingsModel.isGlobalChecked">
            <mat-option *ngFor="let unit of unitValues" [value]="unit">
              {{unit}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="mb-0">
          <mat-label>Unit Type</mat-label>
          <mat-select [(ngModel)]="data.input.dateSettingsModel.globalDueDate.unitType"
                      [disabled]="!data.input.dateSettingsModel.isGlobalChecked">
            <mat-option *ngFor="let type of unitTypes" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="text-center">before Due Date.</div>
    </div>

    <hr>

    <div>
      <div class="header">
        <mat-radio-group [(ngModel)]="data.input.dateSettingsModel.isGlobalChecked">
          <mat-radio-button  [value]="false">Per Report Types</mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="edit-date-settings-options">
        <div class="p-l-5">CbC Notification</div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Value</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.notificationDueDate.unitValue"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let unit of unitValues" [value]="unit">
                {{unit}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Type</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.notificationDueDate.unitType"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let type of unitTypes" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="text-center">before Due Date.</div>

      </div>


      <div class="edit-date-settings-options">
        <div class="p-l-5">CbC Report</div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Value</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.reportDueDate.unitValue"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let unit of unitValues" [value]="unit">
                {{unit}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Type</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.reportDueDate.unitType"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let type of unitTypes" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="text-center">before Due Date.</div>

      </div>

      <div class="edit-date-settings-options">
        <div class="p-l-5">Master File</div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Value</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.mfDueDate.unitValue"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let unit of unitValues" [value]="unit">
                {{unit}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Type</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.mfDueDate.unitType"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let type of unitTypes" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="text-center">before Due Date.</div>

      </div>

      <div class="edit-date-settings-options">
        <div class="p-l-5">Local File</div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Value</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.lfDueDate.unitValue"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let unit of unitValues" [value]="unit">
                {{unit}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="mb-0">
            <mat-label>Unit Type</mat-label>
            <mat-select [(ngModel)]="data.input.dateSettingsModel.lfDueDate.unitType"
                        [disabled]="data.input.dateSettingsModel.isGlobalChecked">
              <mat-option *ngFor="let type of unitTypes" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="text-center">before Due Date.</div>
      </div>
    </div>
  </div>
</div>
